import React from 'react';

function Footer(props){
    return (
        <div className="footer">
            <p><b>© Made by Sanjeev</b> </p>
        </div>
    );
}

export default Footer;